var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsJp = function SvgNnIconFlagsJp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.25 40.25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.13,
    cy: 20.13,
    r: 20,
    fill: "#fff",
    stroke: "#bbbcbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e60013",
    d: "M20.12 10.12a10 10 0 1 1-10 10 10 10 0 0 1 10-10"
  })));
};
export default SvgNnIconFlagsJp;